var replaceContent, setDataType;

replaceContent = function(e, data, status, xhr) {
  var el, replace;
  replace = $(this).data('replace');
  el = replace === true ? $(this).closest('form') : $("#" + replace);
  if (el.size() === 0) {
    console.warn("found no element to replace");
  }
  return el.html(data);
};

setDataType = function(xhr) {
  return $(this).data('type', 'html');
};

$(document).on('ajax:success', '[data-replace]', replaceContent);

$(document).on('ajax:before', '[data-replace]', setDataType);
